import React from 'react'
import { Field } from 'redux-form'
import renderSelect from '../fields/renderSelect'
import renderTextarea from '../fields/renderTextarea'
import i18n from '../../translations/i18n';

const numberArray = [...Array(31).keys()]

let OfficialTranslationOptions = props => {
	let lng = props.lng;
	return (
		<div>
		<div className="row">
			<div className="col-12 form-input">
				<Field
					name="extraCopies"
					component={renderSelect}
					label={i18n.t('official.extra_copy', {lng})}
					placeholder={i18n.t('app.please_select', {lng})}
					options={numberArray}
				/>
			</div>
		</div>
		<div className="row form-section">
			<div className="col-12 form-input">
				<Field
					name="specialInstructions"
					component={renderTextarea}
					label={i18n.t('official.special_instructions', {lng})}
					placeholder={i18n.t('official.special_instructions_placeholder', {lng})}
				/>
			</div>
		</div>
		<div className="row form-section">
			<div className="col-12 form-input">
				<label className='simple-checkbox'>
					<strong>{i18n.t('addons.blockchain_certificate', {lng})}</strong>
					<Field
						name="blockchainCertificate"
						component="input"
						type="checkbox"
						label={i18n.t('addons.blockchain_certificate', {lng})}
						value="blockchainCertificate"
					/>
					<span className="checkboxmark"></span>
				</label>
			</div>
		</div>
	</div>
	)
  }


  export default OfficialTranslationOptions


// WEBPACK FOOTER //
// ./src/components/translation/official_options.js